import { IconProps } from '@models/icons';

function AllIcon(props:IconProps) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <mask id="path-1-inside-1_5317_10702" fill="white">
                <rect x="4.30273" y="5.05554" width="19.1528" height="21.8889" rx="1.16667"/>
            </mask>
            <rect x="4.30273" y="5.05554" width="19.1528" height="21.8889" rx="1.16667" fill="white" stroke="#6E6864"
                strokeWidth="2.8" mask="url(#path-1-inside-1_5317_10702)"/>
            <path
                d="M22.0879 25.5411C21.7013 25.5411 21.3879 25.8545 21.3879 26.2411C21.3879 26.6277 21.7013 26.9411 22.0879 26.9411V25.5411ZM22.0879 16.2698H26.5303V14.8698H22.0879V16.2698ZM26.9969 16.7365V23.4366H28.3969V16.7365H26.9969ZM24.8924 25.5411H22.0879V26.9411H24.8924V25.5411ZM26.9969 23.4366C26.9969 24.5988 26.0547 25.5411 24.8924 25.5411V26.9411C26.8279 26.9411 28.3969 25.372 28.3969 23.4366H26.9969ZM26.5303 16.2698C26.788 16.2698 26.9969 16.4788 26.9969 16.7365H28.3969C28.3969 15.7056 27.5612 14.8698 26.5303 14.8698V16.2698Z"
                fill="#6E6864"/>
            <path d="M9.77539 10.5282H17.9837" stroke="#6E6864" strokeWidth="1.4" strokeLinecap="round"/>
            <path d="M9.77539 15.3159H17.9837" stroke="#6E6864" strokeWidth="1.4" strokeLinecap="round"/>
            <path d="M9.77539 20.1038H17.9837" stroke="#6E6864" strokeWidth="1.4" strokeLinecap="round"/>
        </svg>
    );
}

export default AllIcon;
